app.controller(
    'AdminZoneInfosController', ['$scope', '$rootScope', '$http', '$state', '$stateParams', 'Configuration', 'UserService', '$translate', 'AdminService', '$filter', '$timeout', 'tmhDynamicLocale', AdminZoneInfosController]
);

function AdminZoneInfosController($scope, $rootScope, $http, $state, $stateParams, Configuration, UserService, $translate, AdminService, $filter, $timeout, tmhDynamicLocale) {
    var vm = this;

    $scope.searchText = "search";
    $rootScope.ZoneInfos = {
        CurrentZone: {
            DateDeRestitutionAuteur: '01/01/2017'
        },
        CurrentZoneSourceLanguageText: 'French',
        //DefaultZoneType: 'Classic',
        //ZoneType: [{ name: 'Classic' }, { name: 'Resort' }],
        LanguageList: ['English', 'French', 'Chinois'],
        AvailableLangList: [{ name: 'English' }, { name: 'French' }, { name: 'Chinois' }],
        AssociatedCityList: [{ "name": "1" }, { "name": "2" }, { "name": "3" }, { "name": "4" }, { "name": "5" }]
    };

    if ($stateParams.lang) {
        $scope.CurrentLang = $stateParams.lang;
    }
    else {
        $scope.CurrentLang = 'fr';
    }    

    if ($stateParams.z) {
        vm.ParamZoneId = $stateParams.z;
    }
    else {
        vm.ParamZoneId = 1;
    }

    $scope.config = {
        setHeight: 500
    };

    initController();

    function initController() {
        $translate.use($rootScope.LangForInterface);
        moment.locale($scope.currentLang);
        tmhDynamicLocale.set($rootScope.LangForInterface);
        getAdminZoneInfo(vm.ParamZoneId, $scope.CurrentLang);
    }

    function getAdminZoneInfo(zoneId, lang) {
        AdminService.getAdminZoneInfo(zoneId, lang)
            .then(function (zone) {
                $rootScope.ZoneInfos = zone.data;
                $rootScope.ZoneInfos.CurrentZone.DateDeRestitutionAuteur = $.datepicker.formatDate($rootScope.GlobalDateFormatForMomentDatePicker, new Date($rootScope.ZoneInfos.CurrentZone.DateDeRestitutionAuteur));
                $rootScope.ZoneInfos.CurrentZone.DateDeRestitutionTraducteur = $.datepicker.formatDate($rootScope.GlobalDateFormatForMomentDatePicker, new Date($rootScope.ZoneInfos.CurrentZone.DateDeRestitutionTraducteur));
                $rootScope.ZoneInfos.CurrentZone.DateDePublicationPrint = $.datepicker.formatDate($rootScope.GlobalDateFormatForMomentDatePicker, new Date($rootScope.ZoneInfos.CurrentZone.DateDePublicationPrint));
                $rootScope.ZoneInfos.CurrentZone.DateDePublicationApp = $.datepicker.formatDate($rootScope.GlobalDateFormatForMomentDatePicker, new Date($rootScope.ZoneInfos.CurrentZone.DateDePublicationApp));
                $scope.updateFieldTags();
            });
    }

    vm.IsThisLangDisponible = function (langCode) {
        var result = $.grep($rootScope.ZoneInfos.AvailableLangList, function (a) { return a.actif == true && a.LanguageCode == langCode; });
        if (result.length == 0) {
            return false;
        } else {
            return true;
        }
    }

    vm.GetLangTitle = function (langCode) {
        var result = $.grep($rootScope.ZoneInfos.AvailableLangList, function (a) { return a.LanguageCode == langCode; });
        if (result.length == 0) {
            return 'Not found';
        } else {
            return result[0].name;
        }
    }

    $scope.updateFieldTags = function () {

        $scope.$emit('updateFieldTags');
    };

    vm.SaveAdminCityInfo = function (zoneEdit) {
        //$rootScope.ZoneInfos.CurrentZone.DateDeRestitutionAuteur = moment.parse()
        AdminService.SaveAdminCityInfo(zoneEdit)
                .then(
                    function success(data) { },
                    function error(data) { });
    }

    vm.DeleteZone = function (ZoneInfos) {
        var zoneToBeDeleted = {
            Id: ZoneInfos.CurrentZone.ZoneId
        }

        AdminService.DeleteZone(zoneToBeDeleted)
            .then(function (data) {
                $state.go('app.admin-liste-ville', { lang: $scope.CurrentLang });
            });
    }

    vm.GetCityListByKeyword = function () {
        AdminService.GetCityListByKeyword($stateParams.z, $scope.CurrentLang, $scope.searchText)
            .then(function (data) {
                $rootScope.ZoneInfos.AssociatedCityList = data.data;
            });
    }
}